import { useRef, useState } from 'react';
import { Document, Page } from 'react-pdf';
import { OnDocumentLoadSuccess } from 'react-pdf/dist/cjs/shared/types';
import { useLockBodyScroll } from 'react-use';
import { getPdfPageNumbers, normalizePdfUrl } from './pdf';

export const PDFDocumentView: React.FC<{ url: string }> = ({ url }) => {
  const [numPages, setNumPages] = useState<number>();
  const [loadError, setLoadError] = useState<string>();

  const refScrollSection = useRef<HTMLDivElement | null>(null);
  useLockBodyScroll(true, refScrollSection);

  const onDocumentLoadSuccess: OnDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setLoadError(undefined);
  };

  const secureUrl = normalizePdfUrl(url);

  return (
    <div ref={refScrollSection} className="overflow-auto h-full bg-white">
      {loadError ? (
        <div className="flex h-full flex-col items-center justify-center gap-4 text-gray-500">
          <span>{loadError}</span>
          <a href={secureUrl} target="_blank" rel="noreferrer" className="text-blue-500 underline">
            在新窗口打开 PDF
          </a>
        </div>
      ) : (
        <Document
          className="flex flex-col items-center"
          file={secureUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={(error) => {
            console.error('[PDFDocumentView] load failed', error);
            setLoadError('PDF 加载失败');
          }}
          loading={<div className="p-8 text-gray-500">PDF 加载中...</div>}
        >
          {numPages &&
            getPdfPageNumbers(numPages).map((pageNumber) => (
              <Page width={1000} key={pageNumber} pageNumber={pageNumber} />
            ))}
        </Document>
      )}
    </div>
  );
};
